import 'es6-promise-promise';
import 'reflect-metadata';
import { IProductApiConfig } from '@/Foundation/ProductApi/platform/Scripts/models';
import { setProductCatalogueApiConfig } from '@gn-audio/core/api/product-catalogue/config/actions';
import { setSiteSettingsApiConfig } from '@gn-audio/core/api/site-settings/config/actions';

import './Auth/authenticate-component';
import './Cart/cart';
import './Search/navigation-search';
import './Search/search-focus';
import './V3/site-selector-v3.expand';
import './V3/site-selector-v3.persistence';
import './V3/top-menu-v3';

import { CustomEvent } from '@/Foundation/Shared/platform/app/enums';
import { bootstrapAuthApis, bootstrapUipIfPossible } from '@/Feature/Uip/platform/app/utilities';
import { bootstrapSFCCBasketIfPossible } from '@gn-audio/sfcc-basket/utilities';
import { bootstrapDRBasketIfPossible } from './Cart/utilities/bootstrap-dr-basket-if-possible';
import { setContextAttributes } from './shared/utils/set-context-attributes';

declare var productApiConfig: IProductApiConfig;

(async () => {
  setContextAttributes(productApiConfig);

  setSiteSettingsApiConfig({
    baseUrl: productApiConfig.settingsUrl,
    marketLocale: productApiConfig.language,
    siteContext: productApiConfig.siteContext,
  });
  await setProductCatalogueApiConfig({
    apiKey: productApiConfig.productCatalogueApiKey,
    baseUrl: productApiConfig.productCatalogueUrl,
    marketLocale: productApiConfig.language,
  });

  // This is a temporary solution to make top menu scripts work
  window.dispatchEvent(new Event(CustomEvent.ApiConfigured));

  // Bootstrap features based on their flag state
  await bootstrapAuthApis(productApiConfig);
  await bootstrapSFCCBasketIfPossible();
  await bootstrapDRBasketIfPossible();
  await bootstrapUipIfPossible();
})();
